module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTStd-Lt.4f27a4e5.otf";